import { IAdAdapter } from "./IAdAdapter";

const SDK_URL = "https://sad.adsgram.ai/js/sad.min.js";

async function ensureSDK(): Promise<any> {
  if ((window as any).SAD) return (window as any).SAD;

  await new Promise<void>((resolve, reject) => {
    const existing = document.querySelector(`script[src="${SDK_URL}"]`);
    if (existing) {
      const check = setInterval(() => {
        if ((window as any).SAD) { clearInterval(check); resolve(); }
      }, 100);
      setTimeout(() => { clearInterval(check); reject(new Error("SDK timeout")); }, 5000);
      return;
    }
    const s = document.createElement("script");
    s.src = SDK_URL;
    s.onload = () => setTimeout(() => resolve(), 50);
    s.onerror = () => reject(new Error("SDK load failed"));
    document.head.appendChild(s);
  });

  return (window as any).SAD;
}

export class AdsgramAdapter implements IAdAdapter {
  readonly name = "adsgram";
  private ctrl: any = null;

  constructor(
    private rewardedBlockId: string,
    private interBlockId: string
  ) {}

  isAvailable(): boolean {
    return true; // SDK loaded lazily
  }

  async requestAd(type: "rewarded" | "interstitial"): Promise<boolean> {
    const SAD = await ensureSDK();
    if (!SAD?.init) throw new Error("Adsgram SDK not ready");
    const blockId = type === "rewarded" ? this.rewardedBlockId : this.interBlockId;
    this.ctrl = SAD.init({ blockId });
    return true; // Adsgram always has fill
  }

  async showAd(): Promise<boolean> {
    if (!this.ctrl) throw new Error("no pending ad");
    const ctrl = this.ctrl;
    this.ctrl = null;
    await ctrl.show();
    return true;
  }

  async showAdInterstitial(): Promise<void> {
    if (!this.ctrl) throw new Error("no pending ad");
    const ctrl = this.ctrl;
    this.ctrl = null;
    await ctrl.show();
  }
}
